import { Modal } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import TopBar from '../../components/Layout/TopBar';
import MyButton from '../../components/Layout/MyButton';
import { faEnvelope, faXmark } from '@fortawesome/free-solid-svg-icons';
import { ClipLoader } from 'react-spinners';
import { useAlert } from 'react-alert';
import '../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { method } from 'lodash/util';
import axios from 'axios';
import { URL_API } from '../../utils/globalConfig';
import moment from 'moment';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import { convertToRaw, EditorState } from 'draft-js';
import { logError } from '../../components/Utils/FormatData';
import SelectorTchatChannel from '../../components/AgGrid/SelectorTchatChannel';
import { CHANNEL_TYPE, PROFIL } from '../../constants/enum';
import { MessageContext } from '../../context/MessageContext';

const css = {
    modal: {
        height: '100%',
        width: '100%',
    },
    container: {
        height: '85%',
        width: '90%',
        backgroundColor: 'white',
        borderRadius: '5px',
        margin: 'auto',
    },
    fullRow: {
        height: '100%',
        width: '100%',
        alignItems: 'center',
    },
    row: {
        height: 'calc(100% - 110px)',
        flexDirection: 'column',
        justifyContent: 'normal',
    },
    rowValidation: {
        height: '60px',
        flexDirection: 'column',
        justifyContent: 'normal',
        alignItems: 'flex-end',
    },
    messengerContainer: {
        height: 'calc(100% - 50px)',
        backgroundColor: 'white',
        borderRadius: '5px',
        overflowY: 'hidden',
    },
    tchatItemsContainer: {
        height: '60%',
        borderRadius: '5px',
        paddingTop: '30px',
        overflowY: 'auto',
    },
    tchatTextArea: {
        height: '40%',
    },
    tchatItem: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
    },
    tchatItemContent: {
        display: 'flex',
        maxWidth: '80%',
        position: 'relative',
    },
    tchatOwner: {
        display: 'flex',
        color: 'white',
        fontSize: '24px',
        padding: '10px',
        margin: '10px',
        minWidth: '30px',
        width: '30px',
        height: '30px',
        borderRadius: '50%',
        alignItems: 'center',
        justifyContent: 'center',
    },
    tchatContent: {
        fontSize: '16px',
        paddingTop: '10px',
    },
    tchatContentDescription: {
        fontSize: '18px',
        backgroundColor: '#e9e9e9',
        alignItems: 'center',
        padding: '20px',
        borderRadius: '16px',
        color: 'black',
        minWidth: '200px',
    },
    tchatContentDate: {
        fontSize: '16px',
        marginTop: '5px',
    },
    messengerSendBtnContainer: {
        display: 'flex',
        width: '99%',
        justifyContent: 'flex-end',
        marginRight: '10px',
    },
};

const ModalPlanificationTchat = (props) => {
    const { openModal, setOpenModal, color, planification, user, profil, setNeedReload } = props;
    let currentPlanification = planification.dossier?.planifications.find((planification2) => {
        return planification2.id === planification.id;
    });
    let currentPlanifIndex = planification.dossier?.planifications
    .filter((aPlanification) => aPlanification.deleted === false)
    .sort((a, b) => a.id - b.id)
    .findIndex((aPlanification) => aPlanification.id === planification.id) + 1;
    let nbPlanification = 0;

    if (currentPlanification) {
        nbPlanification = planification.dossier?.metadata.datePassage.nbPassageAller + planification.dossier?.metadata.datePassage.nbPassageRetour;
    }

    const alert = useAlert();
    const [isLoading, setIsLoading] = useState(true);
    const [editorState, setEditorState] = useState(EditorState.createEmpty());
    const [listTchat, setListTchat] = useState([]);
    const [tchat, setTchat] = useState({
        planification: planification.id,
        recipients: [user.login],
        title: 'Tchat planification ' + currentPlanifIndex + '/' + nbPlanification,
        numDossier: planification.dossier_id,
    });
    const { markMessagesAsRead } = useContext(MessageContext);
    let previousRecipient = null;

    //#region useEffect

    useEffect(() => {
        if (openModal) {
            apiGetTchats();
        }
    }, [openModal]);
    useEffect(() => {
        setIsLoading(false);
        if (listTchat.length > 0) {
            let objDiv = document.getElementById('tchatsPlanificationContainer');
            objDiv.scrollTop = objDiv.scrollHeight;
        }
    }, [listTchat]);

    //#endregion

    //#region Functions

    const handleCloseModal = () => {
        if (setNeedReload) {
            setNeedReload(true);
        }
        setIsLoading(false);
        setOpenModal(false);
    };

    const tchatTemplate = (tchat) => {
        let rightPos = tchat.account.user_id === user.user_id;
        let date = moment(tchat.date_message);
        let isSameRecipient = previousRecipient === tchat.account.user_id;
        let authorName = tchat.account.prenom && tchat.account.nom ? tchat.account.prenom + ' ' + tchat.account.nom : tchat.account.email;
        let firstRow = previousRecipient === null;

        previousRecipient = tchat.account.user_id;

        return (<div style={{
            ...css.tchatItem,
            justifyContent: rightPos ? 'right' : 'left',
            marginTop: firstRow ? '0px' : isSameRecipient ? '0px' : '50px',
        }}>
            <div style={rightPos ? {
                ...css.tchatItemContent,
                flexDirection: 'row-reverse',
            } : css.tchatItemContent}>
                {tchatOwner(tchat.account.profil.type, rightPos, isSameRecipient)}
                {!isSameRecipient && <div style={{
                    position: 'absolute',
                    left: rightPos ? 'auto' : '70px',
                    right: rightPos ? '70px' : 'auto',
                    top: '-10px',
                }}>
                    {(profil.profil === PROFIL.INTERVENANT || profil.profil === PROFIL.ADMINISTRATEUR || profil.profil === PROFIL.GESTIONNAIRE) ? authorName : tchat.account.profil.type}
                </div>}
                <div style={css.tchatContent}>
                    <div style={css.tchatContentDescription} dangerouslySetInnerHTML={{ __html: tchat.message }} />
                    <div style={{
                        ...css.tchatContentDate,
                        justifyContent: rightPos ? 'right' : 'left',
                    }}>{date.format('DD/MM/YYYY à HH:mm')}</div>
                </div>
            </div>
        </div>);
    };
    const tchatOwner = (ownerType, isMainRecipient, hidden) => {
        return (<div style={
            {
                ...css.tchatOwner,
                backgroundColor: isMainRecipient ? '#e91e63' : '#0094ca',
                opacity: hidden ? '0' : '1',
            }}>{ownerType.charAt(0).toUpperCase()}</div>);
    };
    const isValidForm = () => {
        if (draftToHtml(convertToRaw(editorState.getCurrentContent())).replace(/<\/?[^>]+(>|$)/g, '').replace('&nbsp;', ' ').trim() === '') {
            return false;
        }
        return true;
    };

    //#endregion

    //#region API

    const apiGetTchats = () => {
        axios({
            method: 'POST', url: `${URL_API}/messagerie/messages-planification`,
            data: {
                id: planification.id,
                userAction: user.user_id,
            },
        })
        .then((response) => {
            alert.removeAll();
            setListTchat([]);
            let planificationTchats = response.data;
            let listNewTchat = [];

            if (planificationTchats.length > 0) {
                markMessagesAsRead(user);
                let recipients = tchat.recipients;

                // On met à jour la liste des destinataires
                planificationTchats.map(function(tchat) {
                    if (!recipients.includes(tchat.account.login)) {
                        recipients.push(tchat.account.login);
                    }

                    listNewTchat.push(tchat);
                });

                setTchat({ ...tchat, recipients: recipients });
                setListTchat(listNewTchat);
            }
        })
        .catch((error) => {
            alert.removeAll();
            alert.error(error.tchat);
        });
    };
    const sendTchat = () => {
        if (isValidForm()) {
            axios({ method: 'post', url: URL_API + '/messagerie/envoi-message', data: buildTchat() })
            .then(() => {
                alert.removeAll();
                alert.success('Le tchat a été envoyé avec succés');
                apiGetTchats();

                setIsLoading(false);
                setTchat({ planification: null, recipients: [], title: '' });
                setEditorState(EditorState.createEmpty());
            })
            .catch((err) => {
                logError(alert, err);
            });
        }
    };
    const buildTchat = () => {
        return {
            expediteur: user.user_id,
            destinataires: tchat.recipients,
            numDossier: planification.dossier_id,
            numPlanification: tchat.planification,
            title: tchat.title,
            message: draftToHtml(convertToRaw(editorState.getCurrentContent())),
            channelType: 'all',
        };
    };

    //#endregion

    return (
        <Modal open={openModal} style={{ display: 'flex' }} disableEscapeKeyDown={true}>
            <div className='modal' style={css.modal}>
                <div style={css.container}>
                    <TopBar title={`Tchat lié a la planification [N°${planification.dossier_id}-${currentPlanifIndex}/${nbPlanification}]`} className='topbar-contenu'
                            color={'#c83b83'}
                            buttons={<div className='topbar-buttons'>
                                <MyButton onClick={() => handleCloseModal()} label='Fermer' icon={faXmark}
                                          sx={{ backgroundColor: '#8F285CFF !important' }} />
                            </div>}
                    />

                    {isLoading && <div className='row' style={css.fullRow}>
                        <ClipLoader color='#0094ca' loading={isLoading} size={75}
                                    css={'display: flex; margin: 25px;justify-content: center;'} />
                    </div>}

                    <div style={css.messengerContainer}>
                        <div style={css.tchatItemsContainer} id='tchatsPlanificationContainer'
                             className='tchats-container'>
                            {listTchat.map(function(tchat, index) {
                                return (tchatTemplate(tchat));
                            })}
                        </div>
                        <div style={css.tchatTextArea}>
                            <div style={{
                                height: '67%',
                                margin: '10px',
                                overflow: 'auto',
                            }}>
                                <Editor
                                    editorState={editorState}
                                    wrapperClassName='demo-wrapper'
                                    editorClassName='demo-editor'
                                    onEditorStateChange={setEditorState}
                                    toolbar={
                                        {
                                            image: {
                                                defaultSize: {
                                                    height: 'auto',
                                                    width: '250',
                                                },
                                            },
                                        }
                                    }
                                />
                            </div>
                            <div style={css.messengerSendBtnContainer}>
                                <MyButton onClick={sendTchat} style='buttonValidationNoMargin' label={'Envoyer'} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );

};

export default ModalPlanificationTchat;
